import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  country: belongsTo('category', { inverse: null }),
  link: belongsTo('link', { inverse: null }),
  logo: belongsTo('asset', { inverse: null }),
  partnerType: belongsTo('category', { inverse: null }),
});
